(function () {
  'use strict';

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function initQuoteBuilder(root) {
    if (!root || root.dataset.ucQuoteInitialized === 'true') return;

    var form = root.querySelector('.uc-quote__form');
    if (!form) return;

    var steps = toArray(form.querySelectorAll('[data-uc-step]'));
    if (!steps.length) return;

    var nextButton = form.querySelector('[data-uc-next]');
    var backButton = form.querySelector('[data-uc-back]');
    var submitButton = form.querySelector('[data-uc-submit]');
    var stepStatus = root.querySelector('[data-uc-step-status]');
    var progressItems = toArray(root.querySelectorAll('[data-uc-progress]'));
    var summaryField = form.querySelector('textarea[name="contact[body]"][data-uc-quote-summary]');
    var review = form.querySelector('[data-uc-review]');
    var currentStep = 0;

    if (!summaryField) {
      summaryField = document.createElement('textarea');
      summaryField.name = 'contact[body]';
      summaryField.hidden = true;
      summaryField.setAttribute('data-uc-quote-summary', '');
      form.appendChild(summaryField);
    }

    function fieldsForStep(step) {
      if (!step) return [];
      return toArray(step.querySelectorAll('input, select, textarea')).filter(function (field) {
        return field && field.type !== 'hidden';
      });
    }

    function validateCurrentStep() {
      var step = steps[currentStep];
      var fields = fieldsForStep(step);

      for (var index = 0; index < fields.length; index += 1) {
        var field = fields[index];
        if (field && !field.checkValidity()) {
          if (typeof field.reportValidity === 'function') field.reportValidity();
          if (typeof field.focus === 'function') field.focus({ preventScroll: true });
          if (typeof field.scrollIntoView === 'function') {
            field.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return false;
        }
      }

      return true;
    }

    function quoteEntries() {
      var entries = [];

      toArray(form.querySelectorAll('[data-uc-label]')).forEach(function (field) {
        if (!field) return;
        if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;

        var value = String(field.value || '').trim();
        var label = String(field.getAttribute('data-uc-label') || '').trim();
        if (!label || !value) return;

        var existing = entries.filter(function (entry) {
          return entry.label === label;
        })[0];

        if (existing) existing.value += ', ' + value;
        else entries.push({ label: label, value: value });
      });

      var selectedComponents = toArray(form.querySelectorAll('[data-rq-solution-component]:checked'))
        .map(function (checkbox) {
          return checkbox ? String(checkbox.value || '').trim() : '';
        })
        .filter(function (value) {
          return value !== '';
        });

      entries.push({
        label: 'Solution components',
        value: selectedComponents.length ? selectedComponents.join(', ') : 'None selected'
      });

      return entries;
    }

    function buildQuoteSummary() {
      var entries = quoteEntries();
      var lines = ['Enterprise Quote Request', ''];

      entries.forEach(function (entry) {
        lines.push(entry.label + ': ' + entry.value);
      });

      if (summaryField) summaryField.value = lines.join('\n');

      if (!review) return;
      review.innerHTML = '';

      entries.forEach(function (entry) {
        var row = document.createElement('div');
        var term = document.createElement('dt');
        var description = document.createElement('dd');
        term.textContent = entry.label;
        description.textContent = entry.value;
        row.appendChild(term);
        row.appendChild(description);
        review.appendChild(row);
      });
    }

    function showStep(index, moveFocus) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function (step, stepIndex) {
        if (!step) return;
        var isActive = stepIndex === currentStep;
        step.hidden = !isActive;
        step.classList.toggle('is-active', isActive);
      });

      progressItems.forEach(function (item, itemIndex) {
        if (!item) return;
        item.classList.toggle('is-active', itemIndex === currentStep);
        item.classList.toggle('is-complete', itemIndex < currentStep);
      });

      if (stepStatus) stepStatus.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;
      if (backButton) backButton.hidden = currentStep === 0;
      if (nextButton) nextButton.hidden = currentStep === steps.length - 1;
      if (submitButton) submitButton.hidden = currentStep !== steps.length - 1;
      if (currentStep === steps.length - 1) buildQuoteSummary();

      if (!moveFocus || !steps[currentStep]) return;

      var legend = steps[currentStep].querySelector('legend');
      if (legend) {
        legend.setAttribute('tabindex', '-1');
        if (typeof legend.focus === 'function') legend.focus({ preventScroll: true });
      }
      if (typeof steps[currentStep].scrollIntoView === 'function') {
        steps[currentStep].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        if (validateCurrentStep()) showStep(currentStep + 1, true);
      });
    }

    if (backButton) {
      backButton.addEventListener('click', function () {
        showStep(currentStep - 1, true);
      });
    }

    form.addEventListener('change', function () {
      if (currentStep === steps.length - 1) buildQuoteSummary();
    });

    form.addEventListener('input', function () {
      if (currentStep === steps.length - 1) buildQuoteSummary();
    });

    form.addEventListener('submit', function (event) {
      if (!validateCurrentStep()) {
        event.preventDefault();
        return;
      }

      buildQuoteSummary();

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Sending…';
      }
    });

    root.dataset.ucQuoteInitialized = 'true';
    showStep(form.querySelector('.uc-quote__errors') ? steps.length - 1 : 0, false);
  }

  function initializeAll(scope) {
    var context = scope && typeof scope.querySelectorAll === 'function' ? scope : document;

    if (context.matches && context.matches('[data-uc-quote-builder]')) {
      initQuoteBuilder(context);
    }

    toArray(context.querySelectorAll('[data-uc-quote-builder]')).forEach(initQuoteBuilder);

    var success = context.querySelector('[data-uc-quote-success]');
    if (success && success.dataset.ucSuccessFocused !== 'true') {
      success.dataset.ucSuccessFocused = 'true';
      if (typeof success.focus === 'function') success.focus();
    }
  }

  function boot() {
    initializeAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.addEventListener('pageshow', boot);
  document.addEventListener('shopify:section:load', function (event) {
    initializeAll(event && event.target ? event.target : document);
  });
})();
